import React from "react";
import { DragDropContextType } from "./types";

export const DragDropContext = React.createContext<
  DragDropContextType | undefined
>(undefined);
